<script>
import ModelEdit from '../models/edit';
import FormsModel from "@/components/forms/service";

export default {
  extends: ModelEdit,
  page: {
    title: "Edit Service",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('services.singular')) }},
    resourceRoute: {default: 'services'},
    modelVariable: {default: 'service'},
    form: {default() { return FormsModel; }},
    denyDelete: {type: Boolean, default: true}
  },
  data() {
    return {
      title: this.lodash.startCase(this.$t('services.plural'))
    }
  },
  mounted() {
    this.fetchModel();
  },
  computed: {
    items() {
      return [
        {
          text: this.lodash.startCase(this.$t('services.plural')),
          href: "/services",
        },
        {
          text: this.model && this.model.id ? this.model['name'] : this.$route.params.key,
          href: `/services/${this.$route.params.key}`,
          active: true,
        },
        {
          text: this.$t('Edit'),
          href: `/services/${this.$route.params.key}/edit`,
          active: true,
        },
      ]
    }
  },
  methods: {
    fetchModel() {
      this.loading = true;
      this.$axios.get(`/shrimps/${this.$route.params.key}`).then((response) => {
        const { data: { data } } = response;
        data.customer_type = data.customer_type.split(',');
        this.model = data;
        return response;
      }).catch((error) => this.failedAlert(error))
      .finally(() => this.loading = false)
    },
    update(value) {
      const body = {...value}
      body.customer_type = value.customer_type.join(',');
      return this.$axios.put(`/shrimps/${this.$route.params.key}`, body)
    },
    delete() {
      return this.$axios.delete(`/shrimps/${this.$route.params.key}`)
    }
  }
}
</script>
